// extracted by mini-css-extract-plugin
module.exports = {"faqListing":"_1oedK","faqItem":"_2n1fZ","faqItem--title":"-CnDe","faqItem--paragraph":"_28sko"};